/**
 * Administrative ICD-10 codes (EHR-8402).
 *
 * These describe *why the visit didn't happen as a clinical encounter* rather
 * than a diagnosis, so there is nothing in the assessment to search from — the
 * clinician has to know the code by heart. They are offered as one-click adds
 * on each episode of care in the billing modal instead.
 *
 * Deliberately kept in the frontend for now. As more codes land here, or when
 * billing is reworked, this should move behind the medical-coding API so
 * codes/versions are owned in one place.
 */

/**
 * Mirrors `ICD10CM_SYSTEM_URL` / `CURRENT_SEARCH_ICD10CM_VERSION` in
 * medical-coding (`app/depends/icd10_search.py`), which is what the ICD-10
 * search returns for every other code the modal submits. If that service bumps
 * its version these must be bumped with it.
 */
export const ICD10_SYSTEM_URL = "http://hl7.org/fhir/sid/icd-10-cm";
export const ICD10_VERSION = "ICD-10-CM 2023";

export interface Icd10QuickAction {
  /** Button copy — the clinician's reason, not the ICD-10 wording. */
  label: string;
  code: string;
  /** Official ICD-10-CM description, sent as the coding `display`. */
  display: string;
}

export const ICD10_QUICK_ACTIONS: Icd10QuickAction[] = [
  {
    label: "Patient no-show",
    code: "Z53.21",
    display:
      "Procedure and treatment not carried out due to patient leaving prior to being seen by health care provider",
  },
  {
    label: "Rx refill",
    code: "Z76.0",
    display: "Encounter for issue of repeat prescription",
  },
];

/** Shape the visit closure form stores for every ICD-10 code. */
export const toIcd10Coding = (action: Icd10QuickAction) => ({
  code: action.code,
  system: ICD10_SYSTEM_URL,
  display: action.display,
  version: ICD10_VERSION,
});
